import { RootState } from '@atredux/store'

export const getIsAnnouncementsFinished = (state: RootState): boolean =>
  state.announcements.isAnnouncementsFinished
